import { Link } from 'react-router-dom';

interface MarketingNavProps {
  actionLabel: string;
  actionTo: string;
  isStoryPage?: boolean;
}

const focusRing =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-how-space-deep focus-visible:ring-offset-4';

export default function MarketingNav({
  actionLabel,
  actionTo,
  isStoryPage = false,
}: MarketingNavProps) {
  const storyItemClass = `justify-self-start whitespace-nowrap text-sm leading-5 text-how-space-mid ${focusRing}`;

  return (
    <nav className="relative z-50 grid h-[104px] shrink-0 grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center px-6 sm:px-10">
      {isStoryPage ? (
        <span className={storyItemClass} aria-current="page">
          Our story
        </span>
      ) : (
        <Link to="/story" className={storyItemClass}>
          Our story
        </Link>
      )}

      <Link to="/" aria-label="Howie home" className={`rounded-sm ${focusRing}`}>
        <img src="/logo_green.svg" alt="Howie" className="h-7 w-auto" />
      </Link>

      <Link
        to={actionTo}
        className={`justify-self-end whitespace-nowrap rounded-full bg-how-space-deep px-5 py-2 text-sm leading-5 text-how-paper-soft transition-colors hover:bg-how-space-mid sm:px-6 ${focusRing}`}
      >
        {actionLabel}
      </Link>
    </nav>
  );
}
